import ScrollPosition from './modules/ScrollPosition';

ScrollPosition.init();
